module.exports = __webpack_public_path__ + "static/media/img_leftpanel.ffd6df5f.jpg";